import { render } from "./updatereservation.vue?vue&type=template&id=6aceb6fa"
import script from "./updatereservation.vue?vue&type=script&lang=js"
export * from "./updatereservation.vue?vue&type=script&lang=js"

import "./updatereservation.vue?vue&type=style&index=0&id=6aceb6fa&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__